import { RouteItem } from '@eastcoal/router/types/route'

import { INUQIRY_AUCTION_SALE_LIST_PAGE_PATH } from './constants/path'

export const inquiryAuctionSaleListRoute: RouteItem = {
  title: '询比价',
  path: INUQIRY_AUCTION_SALE_LIST_PAGE_PATH,
  Component: () => import('./index')
}
